var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100%" } },
    [
      _c(
        "w-card-title",
        [
          _c("span", [_vm._v(_vm._s(_vm.title))]),
          _c("w-spacer"),
          _vm.$wf.isMdUp
            ? _c(
                "w-link",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.close"),
                      expression: "$ct('common.close')",
                    },
                  ],
                  staticClass: "mr",
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.back()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-card-content",
        { staticClass: "content" },
        [
          _c("app-purchase-info", {
            attrs: { value: _vm.purchase, "can-edit": _vm.canEdit },
            on: {
              cancel: function ($event) {
                return _vm.goToBrowse()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }